import { Button, ButtonProps } from 'primereact/button'

import { Row } from './FlexContainer'
import PrimeIcon from './PrimeIcon'
import TraceabilityTag from '../../../models/TraceabilityTag'
import TooltipWrapper from './TooltipWrapper'

interface CopyButtonProps extends ButtonProps {
    copyString: string
}
export default function CopyButton({ copyString, ...props }: CopyButtonProps) {
    if (props.onClick)
        console.warn(
            'Warning: TagIdCopyButton received an `onClick` prop.\n' +
                'This will be ignored because the button handles clicks internally.'
        )
    const onClick = async () => await navigator.clipboard.writeText(copyString)
    return <Button unstyled {...props} onClick={onClick} className="copy-button" />
}

const TAG_ID_LENGTH_LIMIT = 4
interface TagIdCopyButtonProps extends ButtonProps {
    tag?: TraceabilityTag
}
export const TagIdCopyButton = ({ tag, ...props }: TagIdCopyButtonProps) => {
    if (!tag) return undefined

    const tagId = tag.tagId
    let label = tagId
    if (tagId.length > TAG_ID_LENGTH_LIMIT) label = tagId.substring(0, TAG_ID_LENGTH_LIMIT) + '...'
    return (
        <TooltipWrapper label={tagId}>
            <CopyButton {...props} copyString={tagId}>
                <Row arrangement="spaced" gap={0.5}>
                    {label} <PrimeIcon name="clone" />
                </Row>
            </CopyButton>
        </TooltipWrapper>
    )
}
